import { Paintable, Pipeline } from 'ff-canvas';
import { ComputeCache } from 'ff-canvas/dist/util/caching/ComputeCache';
import { drawLoadingPlaceholder } from './drawLoadingPlaceholder';

const loadingPlaceholderCache = new ComputeCache<HTMLCanvasElement>();

export const drawLoadingPlaceholderFor = (paintable: Paintable, pipeline: Pipeline) => {

    const width = pipeline.paintWidthOf(paintable);
    const height = pipeline.paintHeightOf(paintable);
    const transformScale = pipeline.device.transform.scale;
    const key = `${width}x${transformScale.x}x${height}x${transformScale.y}`;

    return loadingPlaceholderCache.access(key, () => {

        const canvas = pipeline
            .storeOf(paintable)
            .canvasFor('loading-placeholder', { width, height });

        const ctx = canvas.getContext('2d')!;

        ctx.fillStyle = 'rgba(0, 0, 0, 0.2)';
        drawLoadingPlaceholder(ctx, width, height);

        return canvas;
    });
};